import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import { twJoin } from 'tailwind-merge';

interface CardSeeAllProps {
  className?: string;
  onClick?: () => void;
  totalGames?: number | string;
  moreButton?: boolean;
}

// После окончания Christmas (06.01.2026) - вернуть все в прежнее состояние МР: FE-12933

const _CardSeeAll = ({ className, onClick, totalGames, moreButton = false }: CardSeeAllProps) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={() => onClick?.()}
      className={twJoin(
        'see-all-card-wrapper flex flex-col justify-center rounded-[10px] overflow-hidden cursor-pointer px-2.5 py-2 relative',
        className
      )}>
      {/* {isEventChristmasActive && (
        <img className="absolute top-0 h-auto w-full self-center" src={patternTop} />
      )} */}
      {/* {isEventChristmasActive && <img className="mb-1 h-auto w-[30%] self-center" src={heart} />} */}
      <p className="see-all-card-title">
        {moreButton ? t('general.moreGames') : t('general.allGames')}
      </p>
      {/* {isEventChristmasActive && (
        <img className="absolute bottom-0 w-full h-auto self-center" src={patternBottom} />
      )} */}
      <p className="see-all-card-content text-center">{totalGames}</p>
    </div>
  );
};

export const CardSeeAll = memo(_CardSeeAll);
